// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { IdlBundle, IdlBundleT, verifyIdlBundle } from "./idl-bundle";
import { IdlOptions, IdlOptionsT, verifyIdlOptions } from "./idl-options";
import { ProductType } from "./product-type";

export class ValidateRequest implements flatbuffers.IUnpackableObject<ValidateRequestT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ValidateRequest {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsValidateRequest(
    bb: flatbuffers.ByteBuffer,
    obj?: ValidateRequest,
  ): ValidateRequest {
    return (obj || new ValidateRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsValidateRequest(
    bb: flatbuffers.ByteBuffer,
    obj?: ValidateRequest,
  ): ValidateRequest {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ValidateRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  productType(): ProductType | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : null;
  }

  bundle(obj?: IdlBundle): IdlBundle | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new IdlBundle()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  options(obj?: IdlOptions): IdlOptions | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new IdlOptions()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  static startValidateRequest(builder: flatbuffers.Builder) {
    builder.startObject(3);
  }

  static addProductType(builder: flatbuffers.Builder, productType: ProductType) {
    builder.addFieldInt8(0, productType, null);
  }

  static addBundle(builder: flatbuffers.Builder, bundleOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, bundleOffset, 0);
  }

  static addOptions(builder: flatbuffers.Builder, optionsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, optionsOffset, 0);
  }

  static endValidateRequest(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // bundle
    return offset;
  }

  unpack(): ValidateRequestT {
    return new ValidateRequestT(
      this.productType(),
      this.bundle() !== null ? this.bundle()!.unpack() : null,
      this.options() !== null ? this.options()!.unpack() : null,
    );
  }

  unpackTo(_o: ValidateRequestT): void {
    _o.productType = this.productType();
    _o.bundle = this.bundle() !== null ? this.bundle()!.unpack() : null;
    _o.options = this.options() !== null ? this.options()!.unpack() : null;
  }

  unpackFields(...fields: string[]): ValidateRequestT {
    const t = new ValidateRequestT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("product_type")) {
      t.productType = this.productType();
    }
    if (fieldSet.has("bundle")) {
      t.bundle = this.bundle() !== null ? this.bundle()!.unpack() : null;
    }
    if (fieldSet.has("options")) {
      t.options = this.options() !== null ? this.options()!.unpack() : null;
    }
    return t;
  }
}

export class ValidateRequestT implements flatbuffers.IGeneratedObject {
  constructor(
    public productType: ProductType | null = null,
    public bundle: IdlBundleT | null = null,
    public options: IdlOptionsT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.bundle === null || this.bundle === undefined) {
      throw new Error('Required field "bundle" is not set');
    }
    const bundle = this.bundle !== null ? this.bundle!.pack(builder) : 0;
    const options = this.options !== null ? this.options!.pack(builder) : 0;

    ValidateRequest.startValidateRequest(builder);
    if (this.productType !== null) ValidateRequest.addProductType(builder, this.productType);
    ValidateRequest.addBundle(builder, bundle);
    ValidateRequest.addOptions(builder, options);

    return ValidateRequest.endValidateRequest(builder);
  }

  clone(): ValidateRequestT {
    const obj = new ValidateRequestT();
    obj.productType = this.productType;
    obj.bundle = this.bundle !== null ? this.bundle!.clone() : null;
    obj.options = this.options !== null ? this.options!.clone() : null;
    return obj;
  }

  equals(other: ValidateRequestT): boolean {
    if (this.productType !== other.productType) return false;
    if (this.bundle !== null && other.bundle !== null) {
      if (!this.bundle!.equals(other.bundle!)) return false;
    } else if (this.bundle !== other.bundle) return false;
    if (this.options !== null && other.options !== null) {
      if (!this.options!.equals(other.options!)) return false;
    } else if (this.options !== other.options) return false;
    return true;
  }
}

export function verifyValidateRequest(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyIdlBundle(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "bundle");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyIdlOptions(verifier, fieldPos + tableOffset);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
